import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import AccountWidget from "../../components/shared/AccountWidget";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import Loading from "../../components/shared/Loading";
import FlashMessage from "../../components/shared/FlashMessage";
import {
  customerGetAddress,
  updateActiveAddress,
  removeAddress
} from "../../store/actions/customer";
import NewAddressForm from "../../components/NewAddressForm";
import EditAddressForm from "../../components/EditAddressForm";
import moment from "moment";
import "moment/locale/tr";
moment.locale("tr");

class Address extends Component {
  state = { edit: false, addressID: null, type: null };
  componentDidMount() {
    this.props.customerGetAddress();
  }

  render() {
    if (this.props.customer.fetching) {
      return <Loading text={"Sayfa Yükleniyor..."} />;
    } else {
      if (!this.props.customer.customer) {
        return (
          <Redirect
            to={{
              pathname: "/giris-yap"
              // state: { referrer: currentLocation }
            }}
          />
        );
      }

      return (
        <React.Fragment>
          <PageTitle title={"Adreslerim"} />
          <div className="row">
            <div className={"container"}>
              <div className="row">
                <div className={"col-md-9"} style={{ marginTop: 15 }}>
                  <h2>Adreslerim</h2>
                  <span className="text-small">
                    Sipariş Teslimat Adreslerim
                  </span>
                  {this.state.edit && (
                    <EditAddressForm
                      {...this.state.edit}
                      closeCallback={() => {
                        this.setState({ edit: false });
                      }}
                    />
                  )}
                  <FlashMessage />
                  <table
                    className={"table table-bordered table-hover"}
                    style={{ marginTop: 20 }}
                  >
                    <thead>
                      <tr>
                        <th>Geçerli Adres</th>
                        <th>Adres Bilgisi</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    {this.props.customer.addresses.length === 0 &&
                    this.props.customer.addressFetching ? (
                      <tbody>
                        <tr>
                          <td colspan={3}>
                            <Loading text={"Adresler Yükleniyor"} />
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        {this.props.customer.addresses.map((address, i) => (
                          <tr key={i}>
                            <td>
                              {address.active && (
                                <button
                                  type={"button"}
                                  className={"btn btn-warning"}
                                  disabled
                                >
                                  <FontAwesomeIcon
                                    icon={["fas", "star"]}
                                    color={"#fff"}
                                  />
                                </button>
                              )}
                            </td>
                            <td>
                              {address.address_name},<br />
                              {address.full_name},<br />
                              {address.address},<br />
                              {address.phone}
                            </td>
                            <td>
                              <a
                                className={"btn btn-success"}
                                // to={{
                                //   pathname: "/hesabim/adres/detay",
                                //   state: {
                                //     id: address.id
                                //   }
                                // }}
                                href={"#"}
                                onClick={e => {
                                  e.preventDefault();
                                  this.setState({ edit: address });
                                }}
                              >
                                <FontAwesomeIcon icon={["fas", "pencil-alt"]} />
                              </a>
                              {!address.active && (
                                <button
                                  title="Geçerli Adres Yap"
                                  disabled={
                                    this.props.customer.addressFetching &&
                                    address.id === this.state.addressID &&
                                    this.state.type === "active"
                                  }
                                  type="button"
                                  className={"btn btn-warning"}
                                  onClick={e => {
                                    e.preventDefault();
                                    this.setState({
                                      addressID: address.id,
                                      type: "active"
                                    });
                                    this.props.updateActiveAddress(address.id);
                                  }}
                                >
                                  {this.props.customer.addressFetching &&
                                  address.id === this.state.addressID &&
                                  this.state.type === "active" ? (
                                    <FontAwesomeIcon icon="spinner" spin />
                                  ) : (
                                    <FontAwesomeIcon icon={["fas", "star"]} />
                                  )}
                                </button>
                              )}

                              {!address.active && (
                                <button
                                  className={"btn btn-danger"}
                                  disabled={
                                    this.props.customer.addressFetching &&
                                    address.id === this.state.addressID &&
                                    this.state.type === "remove"
                                  }
                                  type="button"
                                  onClick={e => {
                                    e.preventDefault();
                                    this.setState({
                                      addressID: address.id,
                                      type: "remove"
                                    });
                                    this.props.removeAddress(address.id);
                                  }}
                                >
                                  {this.props.customer.addressFetching &&
                                  address.id === this.state.addressID &&
                                  this.state.type === "remove" ? (
                                    <FontAwesomeIcon icon="spinner" spin />
                                  ) : (
                                    <FontAwesomeIcon
                                      icon={["fas", "trash-alt"]}
                                    />
                                  )}
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </table>
                  <NewAddressForm />
                  <button
                    className={"btn btn-success"}
                    data-toggle="modal"
                    data-target="#exampleModal"
                    type="button"
                  >
                    Yeni Adres Ekle
                  </button>
                  <br />
                  <br />
                </div>
                <div className={"col-md-3"}>
                  <AccountWidget />
                  <CategoriesWidget />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ customer, order }) => {
  return { customer, order };
};

const mapDispatchToProps = {
  customerGetAddress,
  updateActiveAddress,
  removeAddress
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Address);



// WEBPACK FOOTER //
// ./src/routers/Account/address.js